import React from 'react'

export enum ChevronDirection {
  Up,
  Down,
  Left,
  Right
}

type PropsType = {
  className?: string
  color?: string
  direction?: ChevronDirection
  size?: number
}

const CHEVRON_PATHS = {
  [ChevronDirection.Up]: 'M18 14L16.59 15.41L12 10.83L7.41 15.41L6 14L12 8L18 14Z',
  [ChevronDirection.Down]: 'M18 9.41L16.59 8L12 12.58L7.41 8L6 9.41L12 15.41L18 9.41Z',
  [ChevronDirection.Left]: 'M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z',
  [ChevronDirection.Right]:
    'M10.0001 6L8.59009 7.41L13.1701 12L8.59009 16.59L10.0001 18L16.0001 12L10.0001 6Z'
}

const Chevron = ({
  className,
  color = '#98A1B2',
  direction = ChevronDirection.Down,
  size = 24
}: PropsType) => (
  <svg
    className={className}
    fill={color}
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d={CHEVRON_PATHS[direction]} xmlns='http://www.w3.org/2000/svg' />
  </svg>
)

export default Chevron
